Object.defineProperty(exports, "__esModule", { value: true });
exports.isNullOrUndefined = exports.getEarlyNotificationTime = void 0;
function getEarlyNotificationTime() {
    var earlierTime = new Date();
    earlierTime.setHours(earlierTime.getHours() - 12);
    return earlierTime;
}
exports.getEarlyNotificationTime = getEarlyNotificationTime;
function isNullOrUndefined(obj) {
    return obj === null || obj === undefined;
}
exports.isNullOrUndefined = isNullOrUndefined;
//# sourceMappingURL=notificationHelper.js.map